import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { triggerEvent } from '../helpers/global.js';

import SelectInput from './input/SelectInput';

import '../sass/components/VenuesListView.scss';

const mapStoreToProps = (store) => {
  return {
    user: store.data.user,
    venues: store.data.venues || [],
  }
};

class VenuesListView extends React.Component {
  constructor(props) {
    super(props);
    const venues = this.props.user?.venues || [];
    const selected = this.props.venues;
    this.state = {
      venueId: selected[0] || venues[0]?.id || null,
    }
  }

  componentDidMount = () => {
    triggerEvent('logAmplitude', 'view listing');
  }

  onView = () => {
    const venue = this.props.user.venues.find(i => i.id === this.state.venueId);
    if (venue) {
      window.open(`${process.env.REACT_APP_MAIN_URL}/${venue.url_key}`);
    }
  }

  render = () => {
    const venues = this.props.user?.venues || [];
    return (
      <div className='venuesListView'>
        <div className='listTitle'>View listing</div>
        <div className='listSubtitle'>
          See how your restaurant page looks like on the Burpple platform
        </div>
        <div className='listBlock'>
          <div className='blockTitle'>Select an outlet</div>
          <div className='inputBlock'>
            <label>Outlet</label>
            <SelectInput
              properties={{
                type: 'select',
                options: venues,
              }}
              object={this.state.venueId}
              onChange={(k, value) => {
                this.setState({venueId: value})
              }}
            />
          </div>
          <button onClick={this.onView}>View</button>
        </div>
      </div>
    )
  }
}

export default connect(mapStoreToProps)(withRouter(VenuesListView));
